import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'

// firebase init - add your own config here
var firebaseConfig = {
  apiKey: 'AIzaSyClqiXZQRCVuLDoMI6Gnl0nIFKjor0uRQM',
  authDomain: 'carpe-diem-habit-tracker.firebaseapp.com',
  projectId: 'carpe-diem-habit-tracker',
  storageBucket: 'carpe-diem-habit-tracker.firebasestorage.app',
  messagingSenderId: '860011089382',
  appId: '1:860011089382:web:01cdc2a7bb9d0abecf1a27'
}
firebase.initializeApp(firebaseConfig)

const db = firebase.firestore()
const auth = firebase.auth()

// collection references
const usersCollection = db.collection('users')
const habitsCollection = db.collection('habits')
const logsCollection = db.collection('logs')

// export utils/refs
export { firebase, db, auth, usersCollection, habitsCollection, logsCollection }
